// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__13l7v","footer":"ModalError_footer__3S1PH"};